<div class="modal-container fullscreen">
	<div class="modal-container-body">
		<div class="designer-loader" *ngIf="(promotionCreating$ | async)">
			<div class="loading-spinner-grey"></div>
		</div>
		<div class="design-container">
			<div class="design-left-box">
				<!-- Customization header -->
				<div class="design-left-box-header" [@headerAnimation]="promotionCreated ? 'out' : 'in'">
					<div>
						<span class="design-left-box-header-save-button" appPreventDoubleClick
							(throttledClick)="onSubmit()">{{ 'PREMIUM_PROMOTION_SAVE' | translate}}</span>
						<span class="design-left-box-header-save-button" (click)="back()">{{ 'PREMIUM_PROMOTION_CANCEL'
							| translate }}</span>
					</div>
					<span class="design-left-box-header-save-button-replay" (click)="onReplay()">{{
						'PREMIUM_PROMOTION_REPLAY' | translate }}</span>
				</div>
				<!-- error message -->
				<div class="design-left-box-error" *ngIf="error">
					{{ 'PREMIUM_PROMOTION_ERROR_MESSAGE' | translate }}
				</div>

				<div class="design-left-box-text-content">
					<h1>{{ 'PREMIUM_PROMOTION_CREATE_TITLE' | translate }}</h1>
					<p>
						{{ 'PREMIUM_PROMOTION_CREATE_HELP' | translate }}
					</p>
				</div>



				<!-- Create promotion form -->
				<ng-scrollbar>
					<div class="design-left-box-config-form">
						<form class="form" [formGroup]="promotionCreationForm" (ngSubmit)='onSubmit()'>
							<div class="design-left-box-edition-container">
								<label class="checkbox"
									[ngClass]="{ 'enabled' : checkboxStatus, 'disabled': !checkboxStatus }">
									<div>
										<app-smash-checkbox formControlName="status" [value]="checkboxStatus"
											[(ngModel)]="checkboxStatus" (click)="$event.stopPropagation()">
										</app-smash-checkbox>
									</div>
									<div class="label">
										<ng-container *ngIf="checkboxStatus; else disabled">
											{{ 'PREMIUM_PROMOTION_ENABLED' | translate }}</ng-container>
										<ng-template #disabled>{{ 'PREMIUM_PROMOTION_DISABLED' | translate }}
										</ng-template>
									</div>
								</label>
							</div>

							<!-- Promotion name -->
							<div class="design-left-box-config-form-input">
								<!-- Nom de votre campagne -->
								<app-smash-input type="text" borderStyle="full"
									placeholder="{{ 'PREMIUM_PROMOTION_INPUT_PLACEHOLDER_TITLE' | translate }}"
									formControlName="title" [error]='submitted && f.title.errors'>
								</app-smash-input>
							</div>

							<!-- Promotion teasing text -->
							<div class="design-left-box-config-form-input">
								<!-- Texte de teasing -->
								<app-smash-input type="text" borderStyle="full"
									placeholder="{{ 'PREMIUM_PROMOTION_INPUT_PLACEHOLDER_TEASER' | translate }}"
									formControlName="teaser" [error]='submitted && f.teaser.errors'>
								</app-smash-input>
							</div>

							<!-- Promotion description text -->
							<div class="design-left-box-config-form-input">
								<!-- Description -->
								<app-smash-input type="text" borderStyle="full"
									placeholder="{{ 'PREMIUM_PROMOTION_INPUT_PLACEHOLDER_DESCRIPTION' | translate }}"
									formControlName="text">
								</app-smash-input>
							</div>
							<!-- language -->
							<div class="design-left-box-config-form-input">
								<ng-select class="basic" formControlName="language"
									[items]="supportedLanguages$ | async" bindLabel="name" autofocus bindValue="id"
									[searchable]="false" [clearable]="false" [(ngModel)]="selectedLanguageSync">
								</ng-select>
							</div>

							<!-- Add medias (images/videos) -->
							<h2>{{ 'PREMIUM_PROMOTION_LABEL_PICTURE_VIDEO' | translate }}</h2>
							<div class="design-left-box-config-form-medias">
								<!-- medias List -->
								<ul class="design-left-box-config-form-medias-thumbnails-list">
									<!-- Add medias thumbnail -->
									<li (click)="onAddMedia()"
										class="design-left-box-config-form-medias-thumbnails-list-item"
										[ngClass]="{'empty': submitted && !medias.length}">
										<div class="design-left-box-config-form-medias-thumbnails-list-item-content">
											<span>{{ 'PREMIUM_PROMOTION_PLACEHOLDER_PICTURE_VIDEO' | translate }}</span>
										</div>
									</li>
									<li *ngFor="let media of medias"
										class="design-left-box-config-form-medias-thumbnails-list-item"
										(click)="selectMedia(media)"
										[ngStyle]="{'background-image': resolveSrcUrlString(media.thumbnail)}">
										<div class="design-left-box-config-form-medias-thumbnails-list-item-content">
											<div class="design-left-box-config-form-medias-thumbnails-list-item-content-media-icon"
												*ngIf="media.type === 'Youtube' || media.type === 'Vimeo'">
												<i class="icon-smash_videos"></i>
											</div>
										</div>
										<div class="design-left-box-config-form-medias-thumbnails-list-item-overlay">
											<div
												class="design-left-box-config-form-medias-thumbnails-list-item-overlay-delete">
												<i class="icon-smash_close" (click)="onDeleteMedia(media, $event)"></i>
											</div>
										</div>
									</li>
									<!-- <li *ngIf="creatingMedia" class="design-left-box-config-form-medias-thumbnails-list-item item-loading">
										<div class="spinner-creation-promotion">
											<div class="loading-spinner-grey"></div>
										</div>
									</li> -->
								</ul>
							</div>

							<!-- Promotion call to action -->
							<h2>{{ 'PREMIUM_PROMOTION_LABEL_CALL_TO_ACTION' | translate }}</h2>
							<div class="design-left-box-config-form-input">
								<ng-select class="basic" dropdownPosition="top" [items]="actions" [searchable]="false"
									[clearable]="false" formControlName="button">
									<ng-template ng-label-tmp let-item="item">
										{{ item.translation | translate }}
									</ng-template>
									<ng-template ng-option-tmp let-item="item">
										{{ item.translation | translate }}
									</ng-template>
								</ng-select>
							</div>
							<!-- Promotion action button link -->
							<div class="design-left-box-config-form-input">
								<app-smash-input borderStyle="full"
									placeholder="{{ 'PREMIUM_PROMOTION_PLACEHOLDER_LINK' | translate }}"
									formControlName="link" [error]='submitted && f.link.errors'>
								</app-smash-input>
							</div>

							<h2>{{ 'PREMIUM_PROMOTION_LABEL_TARGET' | translate }}</h2>
							<div class="design-left-box-config-form-input">
								<ng-select class="basic" dropdownPosition="top" bindValue="value" [items]="targets"
									[searchable]="false" [clearable]="false" formControlName="target">
									<ng-template ng-label-tmp let-item="item">
										{{ item.label | translate }}
									</ng-template>
									<ng-template ng-option-tmp let-item="item">
										{{ item.label | translate }}
									</ng-template>
								</ng-select>
							</div>
						</form>
					</div>
				</ng-scrollbar>
			</div>
			<div class="design-right-box">
				<!-- loader overlay -->
				<div class="design-right-box-loader" *ngIf="backgroundIsLoading">
					<app-smash-loading-spinner></app-smash-loading-spinner>
				</div>
				<!-- Customization viewer preview desktop -->
				<div class="design-right-box-content">
					<app-smash-promotion class="design-right-box-preview-container"
						[promotion]="(promotionToCreate$ | async)"
						[inputIndexSelected]="selectedMedia? selectedMedia.index : null">
					</app-smash-promotion>
				</div>

			</div>
			<div class="overlay" *ngIf="(promotionUpdating$ | async)">
				<div class="spinner-update">
					<div class="loading-spinner-grey"></div>
				</div>
			</div>
		</div>
	</div>
</div>